import script from "./StockAdjustment.vue?vue&type=script&setup=true&lang=js"
export * from "./StockAdjustment.vue?vue&type=script&setup=true&lang=js"

import "./StockAdjustment.vue?vue&type=style&index=0&id=6d52435c&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d52435c"]])

export default __exports__